import MuiContainer from "@mui/material/Container";
const Container = MuiContainer;
export default Container;
